import { PaginationResponse } from '@/app/models/pagination';
import { Period } from '@/app/models/period';
import { FormControl, MenuItem, Select, Typography, useTheme } from '@mui/material';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

type PeriodSelectProps = {
  selectedPeriod: Period | undefined;
  setSelectedPeriod: (p: Period | undefined) => void;
  periods: PaginationResponse<Period> | undefined;
};

export default function PeriodSelect(props: PeriodSelectProps) {
  const { i18n, t } = useTranslation(['periodDetails', 'common']);
  const theme = useTheme();

  const { selectedPeriod, setSelectedPeriod, periods } = props;
  return (
    <>
      <Typography sx={{ mx: 3 }} variant="h3" gutterBottom>
        {t('current.period')}
      </Typography>
      <FormControl variant="standard" sx={{ m: 1 }}>
        <Select
          value={selectedPeriod || ({} as Period)}
          size="small"
          sx={{ width: theme.spacing(23) }}
          onChange={(event) => {
            if (event.target.value) {
              setSelectedPeriod(event.target.value as Period);
            }
          }}
        >
          {periods?.content.map((period) => (
            <MenuItem
              sx={{
                fontWeight: period === selectedPeriod ? 'bold' : 'normal',
                color: period === selectedPeriod ? theme.palette.secondary.main : theme.palette.text.primary,
              }}
              key={period.date}
              value={period as any}
            >
              {`${period ? DateTime.fromISO(period.date).setLocale(i18n.language).monthLong : '--'}/${
                period ? DateTime.fromISO(period.date).year : '--'
              }`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
